import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { SimpleConsoleLogger } from "./SimpleConsoleLogger";
import { AdvancedConsoleLogger } from "./AdvancedConsoleLogger";
import { FileLogger } from "./FileLogger";
import { DebugLogger } from "./DebugLogger";
import { ObjectUtils } from "../util/ObjectUtils";
/**
 * Helps to create logger instances.
 */
export var LoggerFactory = /*#__PURE__*/function () {
  function LoggerFactory() {
    _classCallCheck(this, LoggerFactory);
  }
  _createClass(LoggerFactory, [{
    key: "create",
    value:
    /**
     * Creates a new logger depend on a given connection's driver.
     */
    function create(logger, options) {
      if (ObjectUtils.isObject(logger)) return logger;
      if (logger) {
        switch (logger) {
          case "simple-console":
            return new SimpleConsoleLogger(options);
          case "file":
            return new FileLogger(options);
          case "advanced-console":
            return new AdvancedConsoleLogger(options);
          case "debug":
            return new DebugLogger();
        }
      }
      return new AdvancedConsoleLogger(options);
    }
  }]);
  return LoggerFactory;
}();